import { Color } from '../models/color';

export function getUnderscoreClasses(color: Color | undefined) {
  let colorOption = 'hide';

  if (color) colorOption = color;

  return `underscore us-${colorOption}`;
}
